import React, { useEffect, useState } from "react";
import { ImageCard } from "./image-card";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { HOST_API, SALES_FORCE_API_URL } from "../../config-global";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import useModelStore from "../../store/model-store";
import Success from "../success/success";
import { convertErrorsToArray } from "../../utils/formats";
import useSuccessModelStore from "../../store/success-store";
import axiosInstance, { endpoints } from "../../utils/axios";
import { genratePayloadForSalesForceApi } from "./payload";

const Uploader = ({ leadDetail, isMobile, reload }) => {
  const { id } = useParams();
  const { successModalData, setSuccessModalData } = useSuccessModelStore();

  const initialImageCards = [
    { title: "Front of Home", keyForAPi: "frontOfHome" },
    { title: "Front-Left", keyForAPi: "frontLeft" },
    { title: "Front-Right", keyForAPi: "frontRight" },
    { title: "Right Side", keyForAPi: "rightSide" },
    { title: "Left Side", keyForAPi: "leftSide" },
    { title: "Back-Left", keyForAPi: "backLeft" },
    { title: "Back-Right", keyForAPi: "backRight" },
    { title: "Inside K-style gutter run", keyForAPi: "insideKStyleGutterRun" },
    { title: "Inside Box gutter run", keyForAPi: "insideBoxGutterRun" },
    { title: "Inside Super Gutter", keyForAPi: "insideSuperGutter" },
    {
      title: "Box Gutter width  Measurement",
      keyForAPi: "boxGutterWidthMeasurement",
    },
    {
      title: "Super Gutter width Measurement",
      keyForAPi: "superGutterWidthMeasurement",
    },
    { title: "Fascia Board Width", keyForAPi: "fasciaBoardWidth" },
    { title: "Fascia Height", keyForAPi: "fasciaBoardHeight" },
    {
      title: "Soffit width (house to edge)",
      keyForAPi: "soffitWidthHouseToEdge",
    },
    { title: "Soffit panel measurement", keyForAPi: "soffitPanelMeasurement" },
    { title: "Pool screens", keyForAPi: "poolScreens" },
    { title: "Miscellaneous 1", keyForAPi: "miscellaneous1" },
    { title: "Miscellaneous 2", keyForAPi: "miscellaneous2" },
    { title: "Miscellaneous 3", keyForAPi: "miscellaneous3" },
    { title: "Miscellaneous 4", keyForAPi: "miscellaneous4" },
  ];

  const [imageCards, setImageCards] = useState(initialImageCards);
  useEffect(() => {
    // Update imageCards dynamically based on images object
    const updatedCards = initialImageCards.map((card) => ({
      ...card,
      imageUrl: leadDetail?.compressedImages[card.keyForAPi] || null, // Add imageUrl if exists
    }));

    setImageCards(updatedCards);
  }, []);

  const [imagesData, setImagesData] = useState([]);
  const [deleteAbleKeys, setDeleteAbleKeys] = useState([]);
  const [imagesLoading, setImagesLoading] = useState(false);
  const [finnalLoading, setFinnalLoading] = useState(false);
  const { modelData, setModelData } = useModelStore();

  const handleImageChange = async (title, keyForAPi, file, imageData) => {
    if (!file) {
      const filterItems = imagesData.filter(
        (items) => items.keyForAPi != keyForAPi
      );
      setImagesData(filterItems);
      setDeleteAbleKeys((prev) => [...prev, keyForAPi]);
      return;
    } else {
      const filterItems = deleteAbleKeys.filter((items) => items != keyForAPi);
      setDeleteAbleKeys(filterItems);
      setImagesData((prev) => {
        const existingIndex = prev.findIndex(
          (item) => item.keyForAPi === keyForAPi
        );
        if (existingIndex !== -1) {
          const updatedData = [...prev];
          updatedData[existingIndex] = {
            file,
            imageData,
            keyForAPi,
            imageUrl: null,
          };
          return updatedData;
        } else {
          return [...prev, { file, imageData, keyForAPi, imageUrl: null }];
        }
      });
    }
  };

  const handleSubmitAllImages = async (showMsg) => {
    const filterApiImages = imagesData.filter((item) => item.imageUrl == null);
    try {
      const formData = new FormData();
      filterApiImages.forEach((item) => {
        if (item.file) {
          formData.append(`${item.keyForAPi}`, item.file);
        }
      });

      if (filterApiImages.length > 0) {
        const response = await axios.post(
          `${HOST_API}/leads/v1/update-images/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
      if (deleteAbleKeys.length > 0) {
        const deleteResponse = await axios.delete(
          `${HOST_API}/leads/v1/delete-images/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              "Content-Type": "application/json",
            },
            data: { fields: deleteAbleKeys }, // Put request data in the 'data' property
          }
        );
      }
      if (showMsg) {
        toast.success("All images submitted successfully");
        setImagesData([]);
      }
    } catch (error) {
      // Fixed: improved error message formatting
      toast.error(`Failed to submit all images: ${error.message}`);
    } finally {
      setImagesLoading(false);
    }
  };

  const finnalSubmission = async () => {
    setFinnalLoading(true);
    await handleSubmitAllImages(false);
    try {
      await axios.put(
        `${HOST_API}${endpoints.leads.complete_lead(id)}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      const response = await axiosInstance.get(
        endpoints.leads.get_lead_detail(id)
      );
      console.log(SALES_FORCE_API_URL,"what is happening")
      let leadDetail = response.data.data;
      const dataForSalesForce = genratePayloadForSalesForceApi(
        leadDetail,
        leadDetail?.sheets?.gutterSheet,
        leadDetail?.sheets?.orderSheet
      );
      await axios.post(
        SALES_FORCE_API_URL,
        dataForSalesForce,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setModelData({ ...modelData, open: false, steps: 0 });
      setFinnalLoading(false);
      reload();
      setSuccessModalData({ open: true });
      setTimeout(() => {
        setSuccessModalData({ open: false });
      }, 2000);
    } catch (error) {
      setFinnalLoading(false);
      const errorsArray = convertErrorsToArray(error?.response?.data?.data);
      if (errorsArray.length > 0) {
        errorsArray.forEach((err) => toast.error(err));
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("Internal Server Error");
      }
    }
  };
  return (
    <div style={{ position: "relative" }}>
      <span className={"k-form-separator"} />

      <div className={`${!isMobile && "k-scrollable2"} k-mt-4`}>
        <div className="k-text-center">
          <h1 className="k-font-semibold k-sm-heading">Upload Images</h1>
        </div>
        <div className="k-d-grid k-gap-3 image-grid k-mb-10">
          {imageCards.length > 0 &&
            imageCards.map((card, index) => (
              <ImageCard
                isMobile={isMobile}
                key={index}
                title={card.title}
                keyForAPi={card.keyForAPi}
                initialImage={card.imageUrl}
                leadDetail={leadDetail}
                onImageChange={handleImageChange}
              />
            ))}
        </div>
      </div>

      {!leadDetail.mhalt && (
        <div
          className={`k-display-flex k-justify-content-end k-mt-8 ${
            !isMobile && "k-mb-2"
          } k-fixed-footer`}
        >
          <Button
            type="button"
            className="k-mr-2"
            style={{ width: "130px" }}
            disabled={imagesLoading || finnalLoading}
            onClick={() => {
              setImagesLoading(true);
              handleSubmitAllImages(true);
            }}
            size={isMobile ? "small" : "large"}
          >
            {imagesLoading ? (
              <>
                <Loader
                  size="small"
                  type="converging-spinner"
                  style={{ color: "black" }}
                />{" "}
              </>
            ) : (
              "Save As Draft"
            )}
          </Button>
          <Button
            style={{ width: finnalLoading ? "150px" : "160px" }}
            primary={true}
            onClick={() => {
              finnalSubmission();
            }}
            disabled={finnalLoading || imagesLoading}
            className="k-button-green k-mr-3"
            size={isMobile ? "small" : "large"}
          >
            {finnalLoading ? (
              <>
                <Loader
                  size="small"
                  type="converging-spinner"
                  style={{ color: "white" }}
                />{" "}
                Submiting..
              </>
            ) : (
              "Final Submission"
            )}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Uploader;
